export const RECOMMENDED_DEVICE_MAX_QUANTITY = 10;
export const RRP_DISCLAIMER = 'Prices here are recommended only. Your dispensing pharmacy may charge less.';
